import { Step } from "react-joyride";

export const tourSteps: Step[] = [
];
